(function () {
  /* Re-runnable so the product section re-initialises when the Theme Editor
     re-renders it (shopify:section:load). On the storefront this runs exactly
     once — identical to before. The one portaled element (the body-level buy
     bar) is cleared first so a re-render can't leave a duplicate behind. */
  function initProduct() {
    var staleBuybar = document.querySelector('.buybar');
    if (staleBuybar) staleBuybar.remove();
    var main = document.querySelector('.product');
  var title = (main && main.getAttribute('data-product-title')) || '';
  var price = (main && main.getAttribute('data-price')) || '';
  var compare = (main && main.getAttribute('data-compare')) || '';
  var curSize = (main && main.getAttribute('data-current-size')) || '';
  /* Liquid-resolved CTA label — carries the pre-order wording („Užsakyti iš
     anksto") when the product is tagged `netrukus`; falls back to the
     registry default for safety. */
  var atcLabel = (main && main.getAttribute('data-atc-label')) || theme.t('product.add_to_cart');
  /* Per-size pre-order: sizes carrying data-variant-po sell under this label
     instead, and their note fills every [data-po-slot]. Absent → no-op. */
  var poLabel = (main && main.getAttribute('data-po-label')) || '';

  /* ── sticky buy bar (JS-generated), fed with real product title + price ── */
  var buybar = document.createElement('div');
  buybar.className = 'buybar';
  var priceHtml = price + (compare ? ' <s style="opacity:.55">' + compare + '</s>' : '');
  buybar.innerHTML =
    '<div class="buybar__meta">' +
      '<span class="buybar__name"></span>' +
      '<span class="buybar__price"></span>' +
    '</div>' +
    '<span class="buybar__size" data-buybar-size></span>' +
    '<button class="btn btn--primary" type="button" data-buybar-add style="white-space:nowrap;"><span></span></button>';
  /* Appended to <body>, never inside the header: the bar is position:fixed,
     and the header gains transform: translateY(-120%) when it tucks on scroll.
     A transformed ancestor becomes the containing block for fixed descendants,
     so a header-docked bar snapped between viewport-bottom and a point above
     the viewport on every tuck/untuck — the scroll "glitch". <body> never
     transforms, so fixed coordinates stay viewport-true. */
  document.body.appendChild(buybar);
  buybar.querySelector('.buybar__name').textContent = title;
  buybar.querySelector('.buybar__price').innerHTML = priceHtml;
  buybar.querySelector('[data-buybar-add] span').textContent = atcLabel;
  var buybarSize = buybar.querySelector('[data-buybar-size]');
  if (buybarSize) buybarSize.textContent = curSize ? 'EU ' + curSize : '';

  /* The bar appears only once BOTH are true: the in-page CTA has scrolled out of
     reach, and a size has actually been chosen. Gating on scroll alone offered
     „Į krepšelį" on a multi-size product with nothing selected — and the bar
     posts the form's variant input, which is still the default variant at that
     point, so a tap could add a size the shopper never picked.

     „A size is chosen" is read off the in-page CTA's own data-locked flag rather
     than tracked separately, so the two controls can never disagree. A
     single-size product renders unlocked, so its bar behaves exactly as before. */
  var atc = document.querySelector('[data-atc]');
  var pastCtas = false;
  function sizeChosen() { return !(atc && atc.hasAttribute('data-locked')); }
  function syncBuybar() { buybar.classList.toggle('is-visible', pastCtas && sizeChosen()); }

  var ctas = document.querySelector('.ctas');
  var ctaObserver = null;
  if (ctas && 'IntersectionObserver' in window) {
    /* Held in a variable rather than `new IntersectionObserver(...).observe(x)`:
       an unreferenced observer is only kept alive by its own observation list,
       which is a documented footgun. It also gives initProduct() something to
       disconnect when the Theme Editor re-renders the section. */
    ctaObserver = new IntersectionObserver(function (entries) {
      var e = entries[0];
      // past = the CTA block has scrolled ABOVE the viewport
      pastCtas = !e.isIntersecting && e.boundingClientRect.top < 0;
      syncBuybar();
    }, { threshold: 0 });
    ctaObserver.observe(ctas);
  }

  /* ── commerce wiring ── */
  var form = document.querySelector('.product form[action*="/cart/add"]') || document.querySelector('.product form');
  var idInput = document.querySelector('[data-product-id]') || (form && form.querySelector('[name="id"]'));
  var priceCurrent = document.querySelector('.price__current');
  var priceStrike = document.querySelector('.price__strike');

  /* size selection */
  document.querySelectorAll('.size').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.hasAttribute('disabled')) return;

      /* Sold out: say so instead of swallowing the tap, and leave the current
         selection (and the CTA) exactly as it was. */
      if (btn.getAttribute('aria-disabled') === 'true') {
        var soldNote = document.querySelector('[data-sizes-note]');
        if (soldNote) {
          var soldEu = btn.querySelector('.size__eu');
          soldNote.textContent = theme.t('product.size_sold_out', {
            size: soldEu ? soldEu.textContent.trim() : btn.textContent.trim()
          });
          soldNote.hidden = false;
        }
        return;
      }

      document.querySelectorAll('.size').forEach(function (b) {
        b.classList.remove('is-selected');
        b.setAttribute('aria-checked', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-checked', 'true');

      var eu = btn.querySelector('.size__eu');
      var label = eu ? eu.textContent.trim() : btn.textContent.trim();
      if (buybarSize) buybarSize.textContent = 'EU ' + label;

      /* A pre-order size's quantity is the batch allotment, not shelf stock —
         „Liko 2 vnt." would read as ready to ship, so its note replaces it. */
      var poNote = poLabel ? btn.getAttribute('data-variant-po') : null;
      var pickLabel = poNote ? poLabel : atcLabel;
      document.querySelectorAll('[data-po-slot]').forEach(function (el) {
        el.innerHTML = poNote || '';
        el.hidden = !poNote;
      });
      document.querySelectorAll('[data-po-hide]').forEach(function (el) { el.hidden = !!poNote; });

      var note = document.querySelector('[data-sizes-note]');
      if (note) {
        var qty = parseInt(btn.getAttribute('data-variant-qty'), 10);
        if (!poNote && qty > 0 && qty <= 5) { note.textContent = theme.t('product.stock_left', { count: qty }); note.hidden = false; }
        else { note.hidden = true; }
      }

      var vid = btn.getAttribute('data-variant-id');
      if (vid && idInput) idInput.value = vid;

      /* first pick unlocks the CTA (rendered disabled with „Pasirinkite dydį")
         and reveals express checkout, which buys the form's variant directly */
      var atcSpan = atc && atc.querySelector('span');
      if (atc && atc.hasAttribute('data-locked')) {
        atc.removeAttribute('data-locked');
        atc.disabled = false;
        atc.classList.remove('is-locked');
        if (atcSpan) atcSpan.textContent = pickLabel;
        var express = document.querySelector('.ctas__express');
        if (express) express.hidden = false;
        /* first pick may unlock the bar too, if we are already scrolled past */
        syncBuybar();
      } else if (poLabel && atcSpan) {
        atcSpan.textContent = pickLabel;
      }
      if (poLabel) buybar.querySelector('[data-buybar-add] span').textContent = pickLabel;

      /* Per-size deposit: a deposit size submits its selling plan; any other
         size submits none. Express checkout is hidden on deposit sizes for the
         same reason as on deposit pre-order products (see main-product). */
      var sizePlanInput = form && form.querySelector('[data-size-plan]');
      if (sizePlanInput) {
        var sizePlan = btn.getAttribute('data-selling-plan') || '';
        sizePlanInput.value = sizePlan;
        sizePlanInput.disabled = !sizePlan;
        var sizeExpress = document.querySelector('.ctas__express');
        if (sizeExpress) sizeExpress.hidden = !!sizePlan;
      }

      var vp = btn.getAttribute('data-variant-price');
      var vc = btn.getAttribute('data-variant-compare');
      if (vp && priceCurrent) priceCurrent.textContent = vp;
      if (priceStrike) {
        if (vc) { priceStrike.textContent = vc; priceStrike.style.display = ''; }
        else { priceStrike.style.display = 'none'; }
      }
      var bp = buybar.querySelector('.buybar__price');
      if (bp) bp.innerHTML = (vp || price) + (vc ? ' <s style="opacity:.55">' + vc + '</s>' : '');
    });
  });

  /* success UI on an add button */
  function added(btn) {
    if (!btn) return;
    var span = btn.querySelector('span');
    var arrow = btn.querySelector('.btn__arrow');
    if (!span) return;
    var orig = span.textContent;
    span.textContent = theme.t('product.added_short');
    if (arrow) arrow.style.display = 'none';
    setTimeout(function () {
      span.textContent = orig;
      if (arrow) arrow.style.display = '';
    }, 1400);
  }

  /* aria-live status region: announces success, shows errors visibly.
     Visually hidden by default; .is-error makes it a visible inline message. */
  var atcStatus = document.createElement('div');
  atcStatus.className = 'atc-status';
  atcStatus.setAttribute('role', 'status');
  atcStatus.setAttribute('aria-live', 'assertive');
  (function () {
    var host = document.querySelector('.ctas');
    if (host && host.parentNode) { host.parentNode.insertBefore(atcStatus, host.nextSibling); }
    else { document.body.appendChild(atcStatus); }
  })();

  /* real Shopify Cart AJAX add — guarded against double-clicks, surfaces errors */
  var adding = false;
  function addToCart(btn) {
    var id = idInput && idInput.value;
    if (!id || adding) return;
    adding = true;
    if (btn) btn.disabled = true;
    var busySpan = btn && btn.querySelector('span');
    var busyOrig = busySpan ? busySpan.textContent : '';
    if (busySpan) busySpan.textContent = theme.t('product.adding');
    atcStatus.textContent = '';
    atcStatus.classList.remove('is-error');
    /* The payload is hand-built (not FormData), so the pre-order deposit
       plan — a hidden [name="selling_plan"] in the form — must be carried
       over explicitly or checkout silently charges full price. */
    var item = { id: id, quantity: 1 };
    var planInput = form && form.querySelector('[name="selling_plan"]');
    if (planInput && planInput.value && !planInput.disabled) item.selling_plan = planInput.value;
    theme.cart.add([item])
      .then(function () {
        if (busySpan) busySpan.textContent = busyOrig;
        added(btn);
        atcStatus.textContent = theme.t('product.added_to_cart');
      })
      .catch(function (err) {
        if (busySpan) busySpan.textContent = busyOrig;
        atcStatus.textContent = (err && err.userMessage) || theme.t('product.add_error');
        atcStatus.classList.add('is-error');
      })
      .then(function () {
        adding = false;
        if (btn) btn.disabled = false;
      });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart(atc || form.querySelector('[type="submit"]'));
    });
  } else if (atc) {
    atc.addEventListener('click', function () { addToCart(atc); });
  }
  var buybarAdd = buybar.querySelector('[data-buybar-add]');
  if (buybarAdd) buybarAdd.addEventListener('click', function () {
    /* no size picked yet → walk the shopper to the size grid instead of a dead add */
    if (atc && atc.hasAttribute('data-locked')) {
      var sizes = document.querySelector('.sizes[role="radiogroup"]');
      if (sizes) sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    addToCart(buybarAdd);
  });

  /* size radiogroup: roving tabindex + arrow-key navigation (WAI-ARIA APG) */
  (function () {
    var group = document.querySelector('.sizes[role="radiogroup"]');
    if (!group) return;
    var radios = Array.prototype.slice.call(group.querySelectorAll('[role="radio"]'));
    var enabled = radios.filter(function (r) { return !r.disabled; });
    if (!enabled.length) return;
    function setTabStops() {
      var stop = enabled.filter(function (r) {
        return r.getAttribute('aria-checked') === 'true';
      })[0] || enabled[0];
      radios.forEach(function (r) { r.tabIndex = (r === stop) ? 0 : -1; });
    }
    setTabStops();
    group.addEventListener('keydown', function (e) {
      var cur = document.activeElement;
      var i = enabled.indexOf(cur);
      if (i === -1) return;
      var next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { next = enabled[(i + 1) % enabled.length]; }
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { next = enabled[(i - 1 + enabled.length) % enabled.length]; }
      else if (e.key === 'Home') { next = enabled[0]; }
      else if (e.key === 'End') { next = enabled[enabled.length - 1]; }
      else { return; }
      e.preventDefault();
      next.click();
      setTabStops();
      next.focus();
    });
    group.addEventListener('click', setTabStops);
  })();

  /* mobile gallery carousel — sync pagination dots */
  (function () {
    var gallery = document.querySelector('.gallery');
    var dots = Array.prototype.slice.call(document.querySelectorAll('.gallery-dots button'));
    if (!gallery || !dots.length) return;
    var shots = gallery.querySelectorAll('.shot');
    var raf;
    function sync() {
      var i = Math.round(gallery.scrollLeft / gallery.clientWidth);
      i = Math.max(0, Math.min(dots.length - 1, i));
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    }
    gallery.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    }, { passive: true });
    dots.forEach(function (d, n) {
      d.addEventListener('click', function () {
        if (shots[n]) gallery.scrollTo({ left: n * gallery.clientWidth, behavior: 'smooth' });
      });
    });
  })();

  /* tap-to-zoom — the photo AND the magnifier open the lightbox.
     Both were dead: .shot__zoom shipped styled and labelled but was never bound
     to anything, and the image was inert, so every tap on either was a no-op.
     Clarity caught it on four products in three days (the button logs as blank
     text because it holds only an icon; the image logs its "— vaizdas N" alt).
     Delegated from .gallery so it survives the carousel's re-render, and
     flagged so a header-only section reload cannot bind it twice. */
  (function () {
    var gallery = document.querySelector('.gallery');
    var zoom = document.getElementById('productZoom');
    if (!gallery || !zoom || gallery.dataset.zoomWired) return;
    gallery.dataset.zoomWired = '1';
    var big = zoom.querySelector('.zoom__img');
    var frame = zoom.querySelector('.zoom__frame');

    gallery.addEventListener('click', function (e) {
      /* Videos and embeds keep their own controls — only still images zoom. */
      var hit = e.target.closest('.shot__zoom') ||
                (e.target.matches && e.target.matches('img.shot__img') ? e.target : null);
      if (!hit || !big || typeof zoom.open !== 'function') return;
      var shot = hit.closest('.shot');
      var source = shot && shot.querySelector('img.shot__img');
      if (!source) return;
      e.preventDefault();
      /* currentSrc is whichever srcset candidate the browser already decoded,
         so opening the lightbox costs no second download. */
      big.src = source.currentSrc || source.src;
      big.alt = source.alt || '';
      /* Every open starts contained; magnification is opt-in per view. */
      if (frame) frame.classList.remove('is-magnified');
      zoom.open(hit);
    });

    /* Tap the opened photo to magnify past the viewport, tap again to fit.
       Re-centres on toggle so panning starts from the middle of the shoe
       rather than its top-left corner. */
    if (big && frame) {
      big.addEventListener('click', function () {
        var on = frame.classList.toggle('is-magnified');
        if (!on) return;
        frame.scrollLeft = (frame.scrollWidth - frame.clientWidth) / 2;
        frame.scrollTop = (frame.scrollHeight - frame.clientHeight) / 2;
      });
    }
  })();
  }

  initProduct();
  /* Re-init on a product re-render. The bar lives on <body>, so a header
     re-render no longer destroys it and needs no special case here.
     initProduct() removes any surviving .buybar first, so this cannot duplicate. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.product')) initProduct();
  });
})();
